import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already authenticated, redirect to dashboard
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      // Otherwise, redirect to Auth0 login
      loginWithRedirect({
        appState: { returnTo: '/dashboard' }
      });
    }
  }, [isAuthenticated, loginWithRedirect, navigate]);

  return (
    <div className="min-h-screen pt-20 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white flex items-center justify-center">
      <div className="text-center">
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid #FF8C42',
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }} />
        <p style={{ color: '#1a1a3e', fontSize: '1.1rem', fontFamily: 'Georgia, serif' }}>
          Redirecting to login...
        </p>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Login;